const reviewList = [
  "장롱면허라 걱정이 많았는데 <span>마음 편하게 잘 가르쳐주셨어요.</span><br> 운전할때 옆에서 계속 코칭을 해 주시는데 그게 참 도움이 많이<br> 되더라구요. <span>기억에도 잘 남고요.</span> 좀전에 운전관련 법 개정되었다고<br> 카톡 보내주셨는데 애프터서비스까지 완벽하신..^^<br> 앞으로 더 잘되시길 바랍니다.^^",
  "몇년만에 운전시작해서 처음에 엄청떨렸는데 <span><br>차분하게 잘 설명해주셨어요.<span> <br>옆에서 잘한다고 <span>칭찬도 엄청해주셔서 자신감이 많이 올랐어요.</span> <br>덕분에 운전에대해 <span>겁을 덜 먹고</span> 할 수 있을 것 같아요 <br>감사합니다 :).",
  "완전 장롱면허인데 강사님 덕분에 장롱은 탈출했네요 ㅋㅋ<br>첫날부터 차근차근 <span>조근조근하게 작동법 알려주시고</span> 천천히<br>저에게 알맞게 쉽게 설명해주셔서 감사드려요.<br><span>서툰운전에도 당황하지 않고 다독여주며 가르쳐주셔서 </span>너무<br>감사드립니다 ^^",
]

const faqList = [
  {
    Q : "연수신청은 어떻게 하나요?",
    A : "연수신청은 전화나 온라인 신청으로 해주시면 <br>강사님이 수강생분이 계신 곳으로 직접 방문합니다."
  },
  {
    Q : "항상 같은 시간에 교육을 받아야 하나요",
    A : "교육을 진행하시는 강사분과 협의하시면<br> 시간대를 편하게 조절하실 수 있습니다."
  },
  {
    Q : "교육비는 카드결제 가능한가요?",
    A : "교육비는 현금 및 계좌이체로만<br> 결제 가능합니다."
  },
  {
    Q : "강사님이 불친절하면 어떻게 해야 하나요?",
    A : "만약 불친절시 회사로 전화주시면<br> 교체 가능하십니다. (환불 불가능)"
  },
  {
    Q : "원하는 코스로 연수 가능한가요?",
    A : "연수생과 상담 후 코스와 시간을 정하게 됩니다.<br> 연수생이 원하는 코스 (마트, 학교, 직장출퇴근길) 연수 가능합니다."
  },
  {
    Q : "연수 시간은 어떻게 되나요?",
    A : "일반반 (4일과정), 속성반(3일과정/2일과정),<br>주말반(4일과정/2일과정)으로 주부님, 직장인, 학생 등<br> 고객님의 상황에 맞춰 진행하실 수 있습니다."
  },
  {
    Q : "면허딴지가 너무 오래돠어 걱정입니다.<br>운전 감각이 거의 없는데 가능할까요?",
    A : "면허를 딴지 오래되었어도 경험이 많으신 강사님께서 안전하고<br>마음편하게 적응할 수 있도록 도와드립니다. 처음부터 차근차근<br> 부담없이 운전할 수 있도록 최고의 전문 강사님이 함께합니다."
  },
  {
    Q : "연수비 이외에 추가비용이 들어가나요?",
    A : "연수비 이외의 추가비용은 일절 없습니다.<br>(단, 유료주차장 요금 및 고속도로 연수시 발생되는<br> 통행료는 수강생 부담입니다.)"
  },
  {
    Q : "날씨가 좋지 못할 경우 연수는 어떻게 되나요?",
    A : "기상상태가 좋지 못할 경우 안전을 최우선으로 하기 때문에<br> 강사와 협의 후 조정하시면 됩니다."
  },
]

const infoCheck = [
  `'와우킹드라이브'는 (이하 '회사'는) 고객님의 개인정보를 중요시하며, "정보통신망 이용촉진 및 정보보호"에 관한 법률을 준수하고 있습니다. <br><br>

  회사는 개인정보취급방침을 통하여 고객님께서 제공하시는 개인정보가 어떠한 용도와 방식으로 이용되고 있으며, 개인정보보호를 위해 어떠한 조치가 취해지고 있는지 알려드립니다.<br><br>
  
  회사는 개인정보취급방침을 개정하는 경우 웹사이트 공지사항(또는 개별공지)을 통하여 공지할 것입니다.<br><br>
  
  회사는 개인정보취급방침을 개정하는 경우 웹사이트 공지사항(또는 개별공지)을 통하여 공지할 것입니다.<br><br><br>
  
  
  본 방침은 : 2009 년 08 월 10 일 부터 시행됩니다.<br>
  ◎ 수집하는 개인정보 항목<br>
  ◎ 개인정보의 수집 및 이용목적<br>
  ◎ 개인정보의 보유 및 이용기간<br>
  ◎ 개인정보의 파기절차 및 방법<br>
  ◎ 개인정보 제공<br>
  ◎ 수집한 개인정보의 위탁<br>
  ◎ 개인정보 자동수집 장치의 설치, 운영 및 그 거부에 관한 사항<br>
  ◎ 개인정보에 관한 민원서비스<br>
  · 각 항목을 클릭하시면 해당 내용으로 이동합니다.<br>
  <br>
  ◎ 수집하는 개인정보 항목<br>
  회사는 상담신청 등을 위해 아래와 같은 개인정보를 수집하고 있습니다.<br><br>
  
  - 수집항목<br><br>
  
  아이디, 이름, 주소, 집전화, 휴대전화, 이메일<br><br>
  
  - 개인정보 수집방법 : 홈페이지(게시판)<br><br><br>
  
  
  ◎ 개인정보의 수집 및 이용목적<br>
  회사는 수집한 개인정보를 다음의 목적을 위해 활용합니다.<br><br>
  
  - 게시판 서비스제공<br><br><br>
  
  
  ◎ 개인정보의 보유 및 이용기간<br>
  회사는 개인정보 수집 및 이용목적이 달성된 후에는 예외 없이 해당 정보를 지체 없이 파기합니다.<br><br><br>
  
  
  ◎ 개인정보의 파기절차 및 방법<br><br>
  
  회사는 원칙적으로 개인정보 수집 및 이용목적이 달성된 후에는 해당 정보를 지체없이 파기합니다. <br>파기절차 및 방법은 다음과 같습니다.<br><br>
  
  - 파기절차<br><br>
  
  회원님이 상담신청 등을 위해 입력하신 정보는 목적이 달성된 후 별도의 DB로 옮겨져(종이의 경우 별도의 서류함) 내부 방침 및 기타 관련 법령에 의한 정보보호 사유에 따라(보유 및 이용기간 참조) 일정 기간 저장된 후 파기되어집니다.<br>
  별도 DB로 옮겨진 개인정보는 법률에 의한 경우가 아니고서는 보유되어지는 이외의 다른 목적으로 이용되지 않습니다.<br><br>
  
  - 파기방법<br><br>
  
  전자적 파일형태로 저장된 개인정보는 기록을 재생할 수 없는 기술적 방법을 사용하여 삭제합니다.<br><br>
  
  
  ◎ 개인정보 제공<br><br>
  
  회사는 이용자의 개인정보를 원칙적으로 외부에 제공하지 않습니다. 다만, 아래의 경우에는 예외로 합니다.<br><br>
  
  - 이용자들이 사전에 동의한 경우<br>
  - 법령의 규정에 의거하거나, 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는 경우<br><br>
  
  
  ◎ 수집한 개인정보의 위탁<br><br>
  
  회사는 고객님의 동의없이 고객님의 정보를 외부 업체에 위탁하지 않습니다. 향후 그러한 필요가 생길 경우, 위탁 대상자와 위탁 업무 내용에 대해 고객님에게 통지하고 필요한 경우 사전 동의를 받도록 하겠습니다.<br><br><br>
  
  
  ◎ 개인정보 자동수집 장치의 설치, 운영 및 그 거부에 관한 사항<br><br>
  
  쿠키 등 인터넷 서비스 이용 시 자동 생성되는 개인정보를 수집하는 장치를 운영하지 않습니다.<br><br>
  
  ◎ 개인정보에 관한 민원서비스<br><br>
  
  회사는 고객의 개인정보를 보호하고 개인정보와 관련한 불만을 처리하기 위하여 아래와 같이 관련 부서 및 개인정보관리책임자를 지정하고 있습니다.<br><br>
  
  개인정보관리책임자 성명 : <br>
  전화번호 : 053)952-0070<br>
  이메일 :<br>
  
  귀하께서는 회사의 서비스를 이용하시며 발생하는 모든 개인정보보호 관련 민원을 개인정보관리책임자 혹은 담당부서로 신고하실 수 있습니다. 회사는 이용자들의 신고사항에 대해 신속하게 충분한 답변을 드릴 것입니다.<br><br>
  
  기타 개인정보침해에 대한 신고나 상담이 필요하신 경우에는 아래 기관에 문의하시기 바랍니다.<br>
  1.개인분쟁조정위원회 (www.1336.or.kr/1336)<br>
  2.정보보호마크인증위원회 (www.eprivacy.or.kr/02-580-0533~4)<br>
  3.대검찰청 인터넷범죄수사센터(http://icic.sppo.go.kr/02-3480-3600)<br>
  4.경찰청 사이버테러대응센터 (www.ctrc.go.kr/02-392-0330)<br>`
]

export {reviewList, faqList, infoCheck}